module.exports = __webpack_public_path__ + "img/cover.92ac5e1e.jpg";